function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.08
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71 -2.0625C38.3807 -2.0625 11.9375 24.3807 11.9375 57C11.9375 89.6193 38.3807 116.062 71 116.062C103.619 116.062 130.062 89.6193 130.062 57C130.062 24.3807 103.619 -2.0625 71 -2.0625ZM-1.1875 57C-1.1875 17.1319 31.1319 -15.1875 71 -15.1875C110.868 -15.1875 143.188 17.1319 143.188 57C143.188 96.8681 110.868 129.188 71 129.188C31.1319 129.188 -1.1875 96.8681 -1.1875 57Z",
  fill: "#5F5F5F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71 50.4375C74.6244 50.4375 77.5625 53.3756 77.5625 57V83.25C77.5625 86.8744 74.6244 89.8125 71 89.8125C67.3756 89.8125 64.4375 86.8744 64.4375 83.25V57C64.4375 53.3756 67.3756 50.4375 71 50.4375Z",
  fill: "#5F5F5F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71 27.4688C74.6244 27.4688 77.5625 30.4069 77.5625 34.0312V37.3125C77.5625 40.9369 74.6244 43.875 71 43.875C67.3756 43.875 64.4375 40.9369 64.4375 37.3125V34.0312C64.4375 30.4069 67.3756 27.4688 71 27.4688Z",
  fill: "#5F5F5F"
}));

var SvgInfoBackgr = function SvgInfoBackgr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 84,
    viewBox: "0 0 144 84",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoBackgr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/infoBackgr.a820b296.svg";
export { ForwardRef as ReactComponent };